module.exports = __webpack_public_path__ + "litigation-272696d11f8c4cff971478403d3533a0.svg";